import { Injectable } from '@angular/core';
import { format, parseISO } from 'date-fns';

const API_DATE_FORMAT = 'yyyy-MM-dd';
const API_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';

@Injectable({ providedIn: 'root' })
export class ApiDateConverter {
  apiDateToDate = (apiDate: string | Date): Date | undefined => {
    if (typeof apiDate === 'string') {
      return parseISO(apiDate);
    }

    return apiDate;
  };

  dateToApiDate = (date: Date): string | undefined => {
    if (date instanceof Date) {
      return format(date, API_DATE_FORMAT);
    } else {
      console.warn('Invalid date given', date);
    }
  };

  dateTimeToApiDateTime = (date: Date): string | undefined => {
    if (date instanceof Date) {
      return format(date, API_DATE_TIME_FORMAT);
    } else {
      console.warn('Invalid date given', date);
    }
  };
}
